import { render, staticRenderFns } from "./headFirstWidge3.vue?vue&type=template&id=8295e0d4&scoped=true"
import script from "./headFirstWidge3.vue?vue&type=script&lang=js"
export * from "./headFirstWidge3.vue?vue&type=script&lang=js"
import style0 from "./headFirstWidge3.vue?vue&type=style&index=0&id=8295e0d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8295e0d4",
  null
  
)

export default component.exports